import { render, staticRenderFns } from "./AddVendorModal.vue?vue&type=template&id=376e24b2"
import script from "./AddVendorModal.vue?vue&type=script&lang=ts"
export * from "./AddVendorModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports